module.exports = __webpack_public_path__ + "img/perfil.7be63a89.png";